import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/ai-agents')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/ai-agents', ...ROUTE_META['/platform/ai-agents'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'AI Agents', path: '/platform/ai-agents' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/ai-agents', ...ROUTE_META['/platform/ai-agents'] })),
    ],
  }),
});
